module.exports = __webpack_public_path__ + "img/7.9b75062b.jpg";